export enum Token {
  Token = 'token',
  ApiToken = 'api-token',
}
